'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Nav;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _can = require('helpers/can');

var _can2 = _interopRequireDefault(_can);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavbarLink = function NavbarLink(_ref) {
  var to = _ref.to,
      className = _ref.className,
      activeClassName = _ref.activeClassName,
      component = _ref.component,
      children = _ref.children;

  var Comp = component || _reactRouter.Link;

  return _react2.default.createElement(
    Comp,
    { to: to, className: className, activeClassName: activeClassName },
    children
  );
};

function Nav(_ref2) {
  var polyglot = _ref2.polyglot,
      taxonomies = _ref2.taxonomies,
      user = _ref2.user;

  var classes = (0, _classnames2.default)({
    'sidebar-nav': true,
    'navbar-collapse': true,
    collapse: true
  });

  var divStyle = {
    marginBottom: 0
  };

  var count = {
    venues: '',
    events: '',
    notifications: '',
    users: ''
  };

  var logoImage = require('../../assets/images/logo-caligram.svg');

  var canTaxonomy = taxonomies.length > 0;
  var canVenues = user && ((0, _can2.default)('super_admin', [user.calendars, user]) || user.organizations.find(function (org) {
    return org.has_venues;
  }));
  var canOrganizations = user && (['super_admin', 'admin'].indexOf(user.role) > -1 || user.organizations.find(function (org) {
    return ['admin', 'editor'].indexOf(org.role) > -1;
  }));
  var canUsers = ['super_admin', 'admin'].indexOf(user.role) > -1;

  var calendars = (user ? user.calendars : []).map(function (cal) {
    return _react2.default.createElement(
      'li',
      { key: 'calendar-' + cal.id },
      _react2.default.createElement(
        NavbarLink,
        { to: '/calendars/' + cal.id, component: _reactRouter.IndexLink, activeClassName: 'active' },
        cal.name
      )
    );
  });

  return _react2.default.createElement(
    'span',
    null,
    user && _react2.default.createElement(
      'nav',
      { className: 'navbar navbar-default navbar-static-top', role: 'navigation', style: divStyle },
      _react2.default.createElement(
        'div',
        { className: 'navbar-header visible-xs' },
        _react2.default.createElement(
          'button',
          { type: 'button', className: 'navbar-toggle', 'data-toggle': 'collapse', 'data-target': '.navbar-collapse' },
          _react2.default.createElement(
            'span',
            { className: 'sr-only' },
            'Toggle navigation'
          ),
          _react2.default.createElement('span', { className: 'icon-bar' }),
          _react2.default.createElement('span', { className: 'icon-bar' }),
          _react2.default.createElement('span', { className: 'icon-bar' })
        ),
        _react2.default.createElement(
          NavbarLink,
          { to: '/', component: _reactRouter.IndexLink, className: 'navbar-brand' },
          _react2.default.createElement('img', { src: logoImage, alt: 'Caligram' })
        )
      ),
      user && _react2.default.createElement(
        'div',
        { className: 'navbar-default sidebar', role: 'navigation' },
        _react2.default.createElement(
          'div',
          { className: 'logo hidden-xs' },
          _react2.default.createElement('img', { src: logoImage, alt: 'Dashboard Caligram' })
        ),
        _react2.default.createElement(
          'div',
          { className: classes },
          _react2.default.createElement(
            'ul',
            { className: 'nav', id: 'side-menu' },
            (calendars.length > 1 || calendars.length === 0) && _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                NavbarLink,
                { to: '/', component: _reactRouter.IndexLink, activeClassName: 'active' },
                polyglot.t('navigation.all_events')
              )
            ),
            calendars.length > 1 && _react2.default.createElement('li', { className: 'divider' }),
            calendars.length > 0 && _react2.default.createElement(
              'li',
              { className: 'title' },
              polyglot.t('navigation.calendars')
            ),
            calendars,
            ['super_admin'].indexOf(user.role) > -1 && _react2.default.createElement('li', { className: 'divider' }),
            ['super_admin'].indexOf(user.role) > -1 && _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                NavbarLink,
                { to: '/notifications', activeClassName: 'active' },
                polyglot.t('navigation.notifications')
              )
            ),
            _react2.default.createElement('li', { className: 'divider' }),
            canTaxonomy && _react2.default.createElement(
              'li',
              { className: 'title' },
              polyglot.t('navigation.taxonomies')
            ),
            taxonomies.map(function (tax) {
              return _react2.default.createElement(
                'li',
                { key: 'taxonomy-' + tax.id },
                _react2.default.createElement(
                  NavbarLink,
                  { to: '/taxonomies/' + tax.slug, activeClassName: 'active' },
                  tax.name
                )
              );
            }),
            _react2.default.createElement('li', { className: 'divider' }),
            ['super_admin', 'admin'].indexOf(user.role) > -1 && _react2.default.createElement(
              'li',
              { className: 'title' },
              polyglot.t('navigation.manage')
            ),
            canVenues && _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                NavbarLink,
                { to: '/venues', activeClassName: 'active' },
                polyglot.t('navigation.venues'),
                ' ',
                count.venues
              )
            ),
            canOrganizations && _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                NavbarLink,
                { to: '/organizations', activeClassName: 'active' },
                polyglot.t('navigation.organizations')
              )
            ),
            canUsers && _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                NavbarLink,
                { to: '/users', activeClassName: 'active' },
                polyglot.t('navigation.users')
              )
            ),
            _react2.default.createElement('li', { className: 'divider' }),
            _react2.default.createElement(
              'li',
              { className: 'secondary' },
              _react2.default.createElement(
                NavbarLink,
                { to: '/account' },
                polyglot.t('navigation.account')
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'secondary' },
              _react2.default.createElement(
                'a',
                { href: 'https://guide.caligram.com', target: '_blank', rel: 'noopener noreferrer' },
                polyglot.t('navigation.guide')
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'secondary' },
              _react2.default.createElement(
                'a',
                { href: '/logout' },
                polyglot.t('navigation.logout')
              )
            ),
            _react2.default.createElement('li', { className: 'divider' })
          )
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/Nav.js
// module id = 2231
// module chunks = 0